import React, { Component, Fragment } from 'react'
import { Table } from 'antd'
import { get } from 'lodash'
import { dateVal, numVal, strVal } from '../../../modules/Utils'
import RefreshButton from '../../../elements/Buttons/RefreshButton'
import moment from 'moment'
import InfoTooltip from '../../../elements/InfoTooltip'

class LeaveBalance extends Component {
  columns = [
    {
      title: 'Type',
      dataIndex: 'type',
      defaultSortOrder: 'ascend',
      sorter: (a, b) => (a.type.toUpperCase() <= b.type.toUpperCase() ? -1 : 1),
    },
    {
      title: (
        <InfoTooltip
          value={'Entitled'}
          title={'Entitled days for the current period based on contract.'}
        />
      ),
      dataIndex: 'entitled',
      key: 'entitled',
    },
    {
      title: <InfoTooltip value={'Accrued'} title={'Entitlement earned during current period.'} />,
      dataIndex: 'accrued',
      key: 'accrued',
      render: (value, record) => {
        let d = dateVal(this.props.entitlement, 'date.end')
        if (moment(d).isAfter(new Date())) d = dateVal(this.props.entitlement, 'date.start')
        return record.code === 'AL'
          ? Math.round((numVal(record, 'entitled') / 365) * moment().diff(moment(d), 'days'))
          : 0
      },
    },
    {
      title: (
        <InfoTooltip
          value={'Taken'}
          title={'Applied and approved leave regardless whether the leave is taken or not'}
        />
      ),
      dataIndex: 'taken',
      key: 'taken',
      render: value => <span style={{ color: '#ff7d80' }}>{value}</span>,
    },
    {
      title: <InfoTooltip value={'Balance'} title={"It's the total of (Accrued - Taken) "} />,
      dataIndex: 'balance',
      key: 'balance',
      render: (value, record) => {
        let d = dateVal(this.props.entitlement, 'date.end')
        if (moment(d).isAfter(new Date())) d = dateVal(this.props.entitlement, 'date.start')
        return (
          <span style={{ color: '#1890ff' }}>
            {record.code === 'AL'
              ? Math.round((numVal(record, 'entitled') / 365) * moment().diff(moment(d), 'days')) -
                numVal(record, 'taken')
              : numVal(record, 'entitled') - numVal(record, 'taken')}
          </span>
        )
      },
    },
  ]

  render() {
    const { fetchBalance, balance, entitlement, fetchingBalance, member } = this.props
    return (
      <Table
        dataSource={balance}
        loading={fetchingBalance}
        title={() => (
          <Fragment>
            <span>Current Leave Entitlements</span>
            {get(entitlement, 'date.start') && (
              <InfoTooltip
                value={
                  <a style={{ marginLeft: 8 }}>
                    {strVal(entitlement, 'date.start')} -{strVal(entitlement, 'date.end')}
                  </a>
                }
                title={'Current period of entitled leaves based on your contract effective date'}
              />
            )}
            <RefreshButton onClick={() => fetchBalance(member._id)} />
          </Fragment>
        )}
        columns={this.columns}
        size={'small'}
        pagination={false}
      />
    )
  }
}

LeaveBalance.propTypes = {}
LeaveBalance.defaultProps = { member: {} }

export default LeaveBalance
